import { render, staticRenderFns } from "./HomeFruitBanner.vue?vue&type=template&id=05267b84&scoped=true"
import script from "./HomeFruitBanner.vue?vue&type=script&lang=js"
export * from "./HomeFruitBanner.vue?vue&type=script&lang=js"
import style0 from "./HomeFruitBanner.vue?vue&type=style&index=0&id=05267b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05267b84",
  null
  
)

export default component.exports